import { apiGet } from '../api';
import type { ConnectionStatus } from '../types';

function signalBarsHtml(strength: number): string {
  const bars = [1, 2, 3, 4].map((level) =>
    `<div class="signal-bar ${level <= strength ? 'active' : ''}"></div>`
  ).join('');
  return `<div class="signal-bars">${bars}</div>`;
}

function connectionTypeIcon(url: string): string {
  if (url.includes('trycloudflare') || url.includes('tunnel')) {
    return '<svg class="conn-type-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20"/></svg>';
  }
  if (url.includes('10.100.')) {
    return '<svg class="conn-type-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>';
  }
  return '<svg class="conn-type-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0M12 20h.01"/></svg>';
}

/** Render the top connection bar showing active hub + state. */
export function renderConnectionBar(): HTMLElement {
  const bar = document.createElement('div');
  bar.className = 'connection-bar';
  bar.innerHTML = `
    <span class="conn-indicator" id="conn-indicator"></span>
    <span class="conn-hub-name" id="conn-hub-name"></span>
    <span class="conn-label" id="conn-label">Connecting...</span>
    <span id="conn-signal"></span>
    <span id="conn-type-icon"></span>
  `;

  void updateBar(bar);
  return bar;
}

async function updateBar(bar: HTMLElement): Promise<void> {
  const indicator = bar.querySelector<HTMLElement>('#conn-indicator');
  const label = bar.querySelector<HTMLElement>('#conn-label');
  const hubName = bar.querySelector<HTMLElement>('#conn-hub-name');
  const signalEl = bar.querySelector<HTMLElement>('#conn-signal');
  const typeIconEl = bar.querySelector<HTMLElement>('#conn-type-icon');
  if (!indicator || !label) return;

  try {
    const status = await apiGet<ConnectionStatus>('/api/status');
    const state = status.connection_state;

    indicator.className = `conn-indicator conn-${state}`;

    if (state === 'connected') {
      const url = status.active_hub_url;
      const short = url.replace(/^https?:\/\//, '').replace(/:\d+$/, '');
      if (hubName) hubName.textContent = short;
      label.textContent = `${status.discovered_apps} apps`;
      if (signalEl) signalEl.innerHTML = signalBarsHtml(4);
      if (typeIconEl) typeIconEl.innerHTML = connectionTypeIcon(url);
    } else if (state === 'connecting') {
      if (hubName) hubName.textContent = '';
      label.textContent = 'Connecting...';
      if (signalEl) signalEl.innerHTML = signalBarsHtml(1);
      if (typeIconEl) typeIconEl.innerHTML = '';
    } else {
      if (hubName) hubName.textContent = '';
      label.textContent = 'Offline';
      if (signalEl) signalEl.innerHTML = signalBarsHtml(0);
      if (typeIconEl) typeIconEl.innerHTML = '';
    }
  } catch {
    indicator.className = 'conn-indicator conn-offline';
    label.textContent = 'Offline';
    if (hubName) hubName.textContent = '';
    if (signalEl) signalEl.innerHTML = signalBarsHtml(0);
    if (typeIconEl) typeIconEl.innerHTML = '';
  }
}
